export default {
  root: {
    class: [
      //Shape
      'rounded-md',
      '',

      //Color
      'bg-white dark:bg-neutral-900',
      'text-neutral-700 dark:text-neutral-0'
    ]
  },
  body: {
    class: 'px-6'
  },
  title: {
    class: 'text-2xl font-medium mb-2 text-center'
  },
  header: {
    class: ''
  },
  subtitle: {
    class: [
      //Font
      'font-light',

      // Alignment
      'text-center',

      // Size
      'text-sm',

      //Spacing
      'mb-2',

      //Color
      'text-secondary-500 dark:text-neutral-0/60'
    ]
  },
  content: {
    class: 'pt-6' // Vertical padding.
  },
  footer: {
    class: 'pb-6' // Top padding.
  }
}
